import { rem } from 'polished'

const sans =
	'"Inter",-apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, Helvetica, Arial, sans-serif, "Apple Color Emoji", "Segoe UI Emoji", "Segoe UI Symbol"'

const sans2 = '"Inter", ' + sans

const mono = 'Roboto Mono, monospace'
const fonts = { sans, sans2, mono }

const weights = {
	sans: {
		light: 300,
		regular: 400,
		medium: 500,
	},
	mono: {
		light: 300,
		regular: 400,
		medium: 500,
	},
}

const scale = {
	// OLD
	heroTitle: {
		fontSize: rem(82),
		lineHeight: rem(98),
		letterSpacing: rem(-1.64), // -2% → 82 * 0.02 = 1.64
		fontWeight: 300,
	},

	heroTitleXs: {
		fontSize: rem(45),
		lineHeight: rem(54),
		letterSpacing: 0,
		fontWeight: 300,
	},

	//////////////////////////////////////////////////////////////////////////////////////////////////

	bigTitle: {
		fontSize: rem(60),
		lineHeight: rem(72),
		letterSpacing: rem(-1.2),
		fontWeight: 300,
	},

	bigTitleXs: {
		fontSize: rem(42),
		lineHeight: rem(46),
		letterSpacing: 0,
		fontWeight: 300,
	},

	//////////////////////////////////////////////////////////////////////////////////////////////////

	sectionTitle: {
		fontSize: rem(44),
		lineHeight: rem(52),
		letterSpacing: rem(-1.64), // -2% → 82 * 0.02 = 1.64
		fontWeight: 300,
	},

	sectionTitleXs: {
		fontSize: rem(28),
		lineHeight: rem(32),
		letterSpacing: 0,
		fontWeight: 300,
	},

	//////////////////////////////////////////////////////////////////////////////////////////////////

	smallTitle: {
		fontSize: rem(24),
		lineHeight: rem(28),
		letterSpacing: 0,
		fontWeight: 400,
	},

	//////////////////////////////////////////////////////////////////////////////////////////////////

	subtitle: {
		fontSize: rem(25),
		lineHeight: rem(31),
		letterSpacing: 0,
		fontWeight: 400,
	},

	subtitleXs: {
		fontSize: rem(20),
		lineHeight: rem(24),
		letterSpacing: 0,
		fontWeight: 400,
	},

	//////////////////////////////////////////////////////////////////////////////////////////////////

	smallSubtitle: {
		fontSize: rem(22),
		lineHeight: rem(28),
		letterSpacing: 0,
		fontWeight: 400,
	},

	smallSubtitleXs: {
		fontSize: rem(18),
		lineHeight: rem(22),
		letterSpacing: 0,
		fontWeight: 400,
	},

	//////////////////////////////////////////////////////////////////////////////////////////////////

	bodyCopy: {
		fontSize: rem(20),
		lineHeight: rem(24),
		letterSpacing: 0,
		fontWeight: 300,
	},

	bodyCopyXs: {
		fontSize: rem(16),
		lineHeight: rem(22),
		letterSpacing: 0,
		fontWeight: 400,
	},

	//////////////////////////////////////////////////////////////////////////////////////////////////

	link: {
		fontSize: rem(16),
		lineHeight: rem(22),
		letterSpacing: 0,
		fontWeight: 400,
	},

	//////////////////////////////////////////////////////////////////////////////////////////////////

	tag: {
		fontSize: rem(16),
		lineHeight: rem(16),
		letterSpacing: rem(1.12),
		fontWeight: 400,
	},

	tagXs: {
		fontSize: rem(12),
		lineHeight: rem(14),
		letterSpacing: rem(1.12),
		fontWeight: 400,
	},

	//////////////////////////////////////////////////////////////////////////////////////////////////

	smallBodyCopy: {
		fontSize: rem(18),
		lineHeight: 1.17,
		letterSpacing: 0.0,
		fontWeight: 400,
	},

	smallBodyCopyXs: {
		fontSize: rem(14),
		lineHeight: rem(20),
		letterSpacing: 0.0,
		fontWeight: 400,
	},

	//////////////////////////////////////////////////////////////////////////////////////////////////

	captionCopy: {
		fontSize: rem(12),
		lineHeight: 1.2,
		letterSpacing: 0.0,
		fontWeight: 400,
	},

	//////////////////////////////////////////////////////////////////////////////////////////////////

	docsBodyCopy: {
		fontSize: rem(16),
		lineHeight: 1.5,
		letterSpacing: 0.0,
		fontWeight: 400,
	},

	docsBodyCopyXs: {
		fontSize: rem(14),
		lineHeight: 1.25,
		letterSpacing: 0.0,
		fontWeight: 400,
	},

	//////////////////////////////////////////////////////////////////////////////////////////////////

	labelCopy: {
		fontSize: rem(13),
		lineHeight: 1.375,
		letterSpacing: 0.0,
		fontWeight: 400,
	},

	//////////////////////////////////////////////////////////////////////////////////////////////////
	// NEW
	//////////////////////////////////////////////////////////////////////////////////////////////////

	display1: {
		small: `
			font-family: ${fonts.sans};
			font-size: 48px;
			line-height: 64px;
			font-weight: ${weights.sans.regular};
			letter-spacing: -1.5%;
		`,
		regular: `
			font-family: ${fonts.sans};
			font-size: 48px;
			line-height: 64px;
			font-weight: ${weights.sans.regular};
			letter-spacing: -1.5%;
		`,
	},

	display2: {
		small: `
			font-family: ${fonts.sans};
			font-size: 60px;
			line-height: 72px;
			font-weight: ${weights.sans.regular};
			letter-spacing: -1%;
		`,
		regular: `
			font-family: ${fonts.sans};
			font-size: 60px;
			line-height: 72px;
			font-weight: ${weights.sans.regular};
			letter-spacing: -1%;
		`,
	},

	h1: {
		small: `
			font-family: ${fonts.sans};
			font-size: 28px;
			line-height: 1.57;
			font-weight: ${weights.sans.regular};
			letter-spacing: 0%;
		`,
		regular: `
			font-family: ${fonts.sans};
			font-size: 480x;
			line-height: 1.45;
			font-weight: ${weights.sans.regular};
			letter-spacing: -0.02em;
		`,
	},

	h2: {
		small: `
			font-family: ${fonts.sans};
			font-size: 24px;
			line-height: 1.33;
			font-weight: ${weights.sans.regular};
			letter-spacing: 0%;
		`,
		regular: `
			font-family: ${fonts.sans};
			font-size: 36px;
			line-height: 1.33;
			font-weight: ${weights.sans.regular};
			letter-spacing: 0%;
		`,
	},

	h3: {
		small: `
			font-family: ${fonts.sans};
			font-size: 20px;
			line-height: 1.33;
			font-weight: ${weights.sans.regular};
			letter-spacing: 0%;
		`,
		regular: `
			font-family: ${fonts.sans};
			font-size: 24px;
			line-height: 1.33;
			font-weight: ${weights.sans.regular};
			letter-spacing: 0%;
		`,
	},

	h4: {
		small: `
			font-family: ${fonts.sans};
			font-size: 18px;
			line-height: 1.2;
			font-weight: ${weights.sans.medium};
			letter-spacing: 0.15%;
		`,
		regular: `
			font-family: ${fonts.sans};
			font-size: 20px;
			line-height: 1.2;
			font-weight: ${weights.sans.medium};
			letter-spacing: 0.15%;
		`,
	},

	subtitle1: {
		small: `
			font-family: ${fonts.sans};
			font-size: 16px;
			line-height: 24px;
			font-weight: ${weights.sans.medium};
			letter-spacing: 0.1%;
		`,
		regular: `
			font-family: ${fonts.sans};
			font-size: 16px;
			line-height: 24px;
			font-weight: ${weights.sans.medium};
			letter-spacing: 0.1%;
		`,
	},

	subtitle2: {
		small: `
			font-family: ${fonts.sans};
			font-size: 14px;
			line-height: 20px;
			font-weight: ${weights.sans.medium};
			letter-spacing: 0.1%;
		`,
		regular: `
			font-family: ${fonts.sans};
			font-size: 14px;
			line-height: 20px;
			font-weight: ${weights.sans.medium};
			letter-spacing: 0.1%;
		`,
	},

	body1: {
		small: `
			font-family: ${fonts.sans};
			font-size: 16px;
			line-height: 24px;
			font-weight: ${weights.sans.regular};
			letter-spacing: 0.5%;
		`,
		regular: `
			font-family: ${fonts.sans};
			font-size: 16px;
			line-height: 24px;
			font-weight: ${weights.sans.regular};
			letter-spacing: 0.5%;
		`,
	},

	body2: {
		small: `
			font-family: ${fonts.sans};
			font-size: 14px;
			line-height: 20px;
			font-weight: ${weights.sans.regular};
			letter-spacing: 0.25%;
		`,
		regular: `
			font-family: ${fonts.sans};
			font-size: 14px;
			line-height: 20px;
			font-weight: ${weights.sans.regular};
			letter-spacing: 0.25%;
		`,
	},

	caption1: {
		small: `
			font-family: ${fonts.sans};
			font-size: 13px;
			line-height: 20px;
			font-weight: ${weights.sans.regular};
			letter-spacing: 0.5%;
		`,
		regular: `
			font-family: ${fonts.sans};
			font-size: 13px;
			line-height: 20px;
			font-weight: ${weights.sans.regular};
			letter-spacing: 0.5%;
		`,
	},

	caption2: {
		small: `
			font-family: ${fonts.sans};
			font-size: 13px;
			line-height: 20px;
			font-weight: ${weights.sans.medium};
			letter-spacing: 0.25%;
		`,
		regular: `
			font-family: ${fonts.sans};
			font-size: 13px;
			line-height: 20px;
			font-weight: ${weights.sans.medium};
			letter-spacing: 0.25%;
		`,
	},

	code: {
		small: `
			font-family: ${fonts.mono};
			font-size: 13px;
			line-height: 20px;
			font-weight: ${weights.mono.regular};
			letter-spacing: 0%;
		`,
		regular: `
			font-family: ${fonts.mono};
			font-size: 13px;
			line-height: 20px;
			font-weight: ${weights.mono.regular};
			letter-spacing: 0%;
		`,
	},
}

const typography = { fonts, scale, weights }

export default typography
